import { ArrowRight } from "lucide-react";
import {
  formatSnapshotFieldName,
  formatSnapshotValue,
} from "../../../../lib/approvalLabels";

interface ScalarFieldDiffRowProps {
  field: string;
  oldValue: unknown;
  newValue: unknown;
}

export function ScalarFieldDiffRow({
  field,
  oldValue,
  newValue,
}: ScalarFieldDiffRowProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 text-sm border-b border-stone-100 last:border-b-0 bg-amber-50/50">
      <span className="font-medium text-stone-500 w-36 flex-shrink-0">
        {formatSnapshotFieldName(field)}
      </span>
      <div className="flex items-baseline gap-2 min-w-0 flex-wrap">
        <span className="text-stone-400 line-through break-words">
          {formatSnapshotValue(oldValue)}
        </span>
        <ArrowRight className="h-3 w-3 text-stone-400 flex-shrink-0" />
        <span className="font-medium break-words">
          {formatSnapshotValue(newValue)}
        </span>
      </div>
    </div>
  );
}
